import React from "react";
import clsx from "clsx";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { Close } from "@mui/icons-material";

import { getHeaderBgColor } from "slices/property-slice/index";

const ShowTimeSlots = ({ timeSlotsRef, availableTimeSlots, handleClick, inputValues, handleClose, time }) => {
  const backgroundColor = useSelector(getHeaderBgColor);

  return (
    <div className="hayley-absolute hayley-bottom-0 hayley-left-0 hayley-right-0 hayley-top-0 hayley-z-30 hayley-flex hayley-h-full hayley-w-full hayley-items-center hayley-justify-center hayley-bg-[#333333CC]">
      <div
        className=" modal-shadow hayley-h-fit hayley-w-full hayley-max-w-[380px]  hayley-select-none hayley-rounded-[4px] hayley-border hayley-border-solid hayley-border-custom-6 hayley-bg-white hayley-p-5"
        ref={timeSlotsRef}
      >
        <div className="hayley-col-span-7 -hayley-m-2 hayley-flex hayley-h-5 hayley-min-w-[252px] hayley-items-center hayley-justify-end hayley-align-middle ">
          <Close
            onClick={handleClose}
            className="hayley-right-1 hayley-top-4 hayley-z-50 hayley-h-4 hayley-w-4 hayley-cursor-pointer"
            sx={{ "&:hover": { color: `${backgroundColor} !important` } }}
          />
        </div>
        <div className="hayley-flex hayley-flex-col hayley-gap-4">
          {availableTimeSlots.morning.length ? (
            <div>
              <p className="hayley-m-0 hayley-mb-2 hayley-text-xs hayley-font-semibold hayley-text-custom-8">{t("morning")}</p>

              <div className="hayley-flex hayley-flex-wrap hayley-gap-2 hayley-text-xs">
                {availableTimeSlots.morning.map(({ label, value }) => (
                  <div
                    key={value}
                    className={clsx(
                      "hayley-cursor-pointer hayley-rounded-[20px] hayley-border hayley-border-solid  hayley-px-3 hayley-py-[6px] hayley-text-secondary",
                      {
                        "hayley-border-custom-6 ": inputValues?.["time"] !== value || time !== value,
                        "hayley-border-secondary hayley-font-semibold ": inputValues?.["time"] === value || time == value,
                      }
                    )}
                    onClick={() => {
                      handleClick(value);
                      handleClose();
                    }}
                  >
                    {label}
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {availableTimeSlots.afternoon.length ? (
            <div>
              <p className="hayley-m-0 hayley-mb-2 hayley-text-xs hayley-font-semibold hayley-text-custom-8">{t("afternoon")}</p>

              <div className="hayley-flex hayley-flex-wrap hayley-gap-2 hayley-text-xs">
                {availableTimeSlots.afternoon.map(({ label, value }) => (
                  <div
                    key={value}
                    className={clsx(
                      "hayley-cursor-pointer hayley-rounded-[20px] hayley-border hayley-border-solid  hayley-px-3 hayley-py-[6px] hayley-text-secondary",
                      {
                        "hayley-border-custom-6": inputValues?.["time"] !== value || time !== value,
                        "hayley-border-secondary hayley-font-semibold ": inputValues?.["time"] === value || time == value,
                      }
                    )}
                    onClick={() => {
                      handleClick(value);
                      handleClose();
                    }}
                  >
                    {label}
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ShowTimeSlots;
